// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AdditionalServicePrices_RemoverInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de POST /so/additional_service_prices/remover
 * (controllers/so/additional_service_prices.php::remover).
 *
 * Um campo, OBRIGATORIO: a linha a desligar. "Remover" aqui e soft-delete
 * (`active = 0`) e tem SEMANTICA: a franquia desliga o adicional — ele some
 * do modal de item dela e a linha continua visivel na gestao para religar.
 */
import { registerContract } from './validate'

export interface AdditionalServicePrices_RemoverInput {
so_additional_service_price_id: number
}

registerContract('AdditionalServicePrices_RemoverInput', {
  so_additional_service_price_id: { type: 'number',  required: true },
})
